module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "figcenter"
  }, [_c('img', {
    staticClass: "calibre16",
    attrs: {
      "alt": "MRS. SLATER AND SUE WATCH BUNNY AND HARRY BRING IN THE BOX.",
      "id": "id-7891929519208952251",
      "src": "Images/img0001.jpg",
      "title": "MRS. SLATER AND SUE WATCH BUNNY AND HARRY BRING IN THE BOX."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("MRS. SLATER AND SUE WATCH BUNNY AND HARRY BRING IN THE BOX.")])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "calibre17"
  }, [_vm._v("Bunny Brown and His Sister Sue at Christmas Tree Cove.")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('i', {
    staticClass: "calibre17"
  }, [_vm._v("Frontispiece")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0